module.exports = __webpack_public_path__ + "img/NewmandL.0a09a4a2.jpg";